import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api, resolveImageUrl } from "../lib/config";

const DEFAULT_FOUNDERS = [
  {
    key: "carlo",
    name: "Carlo de Caprio",
    role: "Co-Fondatore",
    bio: "Anima del progetto Fanta Partenope. Dalla passione per il fantacalcio all'idea di una community napoletana unica.",
  },
  {
    key: "antonio",
    name: "Antonio Micera",
    role: "Co-Fondatore",
    bio: "Voce e volto della community.",
  },
  {
    key: "tony",
    name: "Tony Rega",
    role: "Co-Fondatore",
    bio: "Mente strategica del torneo. Cura regolamento, premi e l'esperienza competitiva di ogni partecipante.",
  },
];

export default function Founders() {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings(r.data || {})).catch(() => {});
  }, []);

  const founders = DEFAULT_FOUNDERS.map((f) => ({
    ...f,
    img: resolveImageUrl(settings[`founder_${f.key}_img`] || ""),
    bio: settings[`founder_${f.key}_bio`] || f.bio,
  }));

  return (
    <section id="fondatori" className="relative py-24 md:py-32 px-5 md:px-8" data-testid="founders-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="text-xs tracking-[0.4em] uppercase text-fp-cyan font-heading font-semibold">
            Il team dietro al torneo
          </div>
          <h2 className="mt-4 font-heading font-black text-4xl md:text-5xl lg:text-6xl tracking-tight">
            <span className="silver-gradient">Fondatori</span>
          </h2>
          <p className="mt-5 text-white/60 max-w-2xl mx-auto">
            Tre napoletani, una passione condivisa. Il progetto è nato nel 2023 ed è oggi ufficialmente un'Associazione Sportiva Dilettantistica.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {founders.map((f, i) => (
            <motion.div
              key={f.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.15, duration: 0.6 }}
              className="group relative rounded-3xl overflow-hidden border border-white/10 bg-fp-surface/50 hover:border-fp-cyan/40 transition-all duration-500"
              data-testid={`founder-${i}`}
            >
              <div className="relative aspect-[4/5] overflow-hidden bg-fp-bg">
                {f.img ? (
                  <img
                    src={f.img}
                    alt={f.name}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-white/20 text-6xl font-heading font-black">
                    {f.name.split(" ").map((p) => p[0]).join("")}
                  </div>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-fp-bg via-fp-bg/40 to-transparent" />
              </div>
              <div className="relative -mt-16 p-7 md:p-8">
                <div className="text-[10px] tracking-[0.3em] uppercase text-fp-cyan font-heading font-semibold">
                  {f.role}
                </div>
                <h3 className="mt-2 font-heading font-black text-2xl md:text-3xl tracking-tight">
                  {f.name}
                </h3>
                <p className="mt-4 text-white/60 text-sm leading-relaxed">{f.bio}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
